import { AdditionalServicesI } from '../types/additional_services.types'

export const EMPTY_ADDITIONAL_SERVICES: AdditionalServicesI = {
    hasCar: false,
    hasSoftPackage: false,
    hasRisingToTheFloor: false,
    hasManipulator: false,
    hasCrane: false,
    hasHydraulicTrolley: false,
    hasGrid: false,
    hasLoader: false,
    hasPallet: false,
}

export const ADDITIONAL_SERVICES = [
    {
        key: 'value',
        value: 'Количество',
    },
    {
        key: 'duration',
        value: 'Продолжительность (себестоимость)',
    },
    {
        key: 'duration_client',
        value: 'Продолжительность (клиенту)',
    },
    {
        key: 'cost_per_hour',
        value: 'Себестоимость за час',
    },
    {
        key: 'paid_price_per_hour',
        value: 'Выставление клиенту за час',
    },
    {
        key: 'cost_total',
        value: 'Общая себестоимость',
    },
    {
        key: 'paid_price_total',
        value: 'Общая сумма к оплате',
    },
    {
        key: 'carrier_name',
        value: 'Перевозчик',
    },
]
